import { Controller } from "@hotwired/stimulus"

// Sprint 2 (01/06/2026) — Sur le form de création/édition DealB2c, pré-remplit
// automatiquement end_date à start_date + 3 mois quand l'utilisateur saisit la
// date de début. Clémentine confirme que la durée standard B2C tertiaire est
// 3 mois ; modifiable manuellement (un changement manuel sur end_date verrouille
// l'autofill pour ne pas écraser sa saisie).
export default class extends Controller {
  static targets = ["startDate", "endDate"]

  connect() {
    this.manuallyEdited = this.endDateTarget.value !== ""
  }

  markManual() {
    this.manuallyEdited = true
  }

  updateEnd() {
    if (this.manuallyEdited) return
    const startValue = this.startDateTarget.value
    if (!startValue) return
    const start = new Date(startValue)
    if (Number.isNaN(start.getTime())) return
    const end = new Date(start)
    end.setMonth(end.getMonth() + 3)
    const yyyy = end.getFullYear()
    const mm = String(end.getMonth() + 1).padStart(2, "0")
    const dd = String(end.getDate()).padStart(2, "0")
    this.endDateTarget.value = `${yyyy}-${mm}-${dd}`
  }
}
